import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "winning-distribution-table" }
const _hoisted_2 = { class: "t-table-header" }
const _hoisted_3 = {
  class: "t-table",
  "data-qe-id": "prizes-table"
}
const _hoisted_4 = { class: "rank" }
const _hoisted_5 = { class: "rank" }
const _hoisted_6 = { key: 0 }

import { ref, Ref, computed, watch } from 'vue'
import { useRoute } from 'vue-router'
import events from '@gd/event-bus'
import { useStore } from '@/store'
import { WinningDistribution } from '@/store/modules/winningDistribution'
import CTournamentInfo from '@/components/CTournamentInfo.vue'
import { TournamentUi } from '../model/Tournament'
import { track } from '@/lib/track'
import { jslog } from '@gd/jslog'


export default /*@__PURE__*/_defineComponent({
  __name: 'MWinningDistribution',
  setup(__props) {

const route = useRoute()
const store = useStore()
const isReady = ref(false)
const show = ref(false)
const tId = ref('')
const tournamentUi: Ref<TournamentUi> = ref()
function created() {
  events.$on('tournament-info-modal', (config: { tId: string; tournamentUi: TournamentUi; trackId: string }) => {
    tId.value = config && (config.tId || config.tournamentUi.tournamentId)
    tournamentUi.value = config && config.tournamentUi
    if (tId.value) {
      show.value = true
      isReady.value = false
      store
        .dispatch('winningDistribution/fetchWinningDistributionById', tId.value)
        .then(() => {
          isReady.value = true
        })
        .catch((err) => {
          onClose()
          jslog.send({ name: 'fatal', data: { message: 'could not open winning distribution modal' } })
        })
      track({
        id: 'winning-distribution-modal',
        path: route.fullPath,
        data: (config && config.trackId) || '-',
      })
    } else {
      console.error("can' show tournament info modal - because of missing properties")
    }
  })
}

// watch(show, (newValue: boolean, oldValue: boolean) => {
//   if (oldValue === false) {
//   }
// })

const stages = computed(() => {
  return store.getters['winningDistribution/stages']
})

const distributionData = computed((): WinningDistribution => {
  return store.state.winningDistribution.current
})

function onClose() {
  show.value = false
}

created()

return (_ctx: any,_cache: any) => {
  const _component_c_loading_indicator = _resolveComponent("c-loading-indicator")!
  const _component_modal_title = _resolveComponent("modal-title")!
  const _component_t_text = _resolveComponent("t-text")!
  const _component_modal_content = _resolveComponent("modal-content")!
  const _component_modal_layout = _resolveComponent("modal-layout")!
  const _component_modal_app = _resolveComponent("modal-app")!
  const _component_gd_modal = _resolveComponent("gd-modal")!

  return (show.value)
    ? (_openBlock(), _createBlock(_component_gd_modal, {
        key: 0,
        onClose: onClose,
        onCloseBG: onClose,
        onCloseESC: onClose,
        "data-qe-id": "win-distribution-modal"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_c_loading_indicator, {
            show: !isReady.value
          }, null, 8, ["show"]),
          _createVNode(_component_modal_app, {
            class: _normalizeClass(['winning-distribution', { 'has-tournament-info': tournamentUi.value }]),
            s: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_modal_layout, null, {
                default: _withCtx(() => [
                  _createVNode(_component_modal_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(distributionData.value.name), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_modal_content, null, {
                    default: _withCtx(() => [
                      (tournamentUi.value)
                        ? (_openBlock(), _createBlock(_component_t_text, {
                            key: 0,
                            class: "tournament-info-section"
                          }, {
                            default: _withCtx(() => [
                              (tournamentUi.value.tournamentId)
                                ? (_openBlock(), _createBlock(CTournamentInfo, {
                                    key: 0,
                                    "tournament-ui": tournamentUi.value,
                                    "info-icon": false,
                                    headline: _ctx.$t('winningDistribution.main.title'),
                                    class: "tournament-info-box",
                                    gameName: "",
                                    totalWin: "",
                                    addedPrize: "",
                                    entryFee: "",
                                    restartFee: "",
                                    competitionDate: "",
                                    lobbyTime: "",
                                    registrationDate: "",
                                    tournamentMode: ""
                                  }, null, 8, ["tournament-ui", "headline"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('winningDistribution.table.header')), 1),
                        _createElementVNode("table", _hoisted_3, [
                          _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.$t('winningDistribution.table.rank')), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.$t('winningDistribution.table.price')), 1)
                            ])
                          ]),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stages.value, (stage) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: stage.index
                              }, [
                                _createElementVNode("td", _hoisted_5, [
                                  _createTextVNode(_toDisplayString(stage.from) + " ", 1),
                                  (stage.to != stage.from)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, "- " + _toDisplayString(stage.to), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("td", null, _toDisplayString(stage.prize), 1)
                              ]))
                            }), 128))
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})